
define('text!templates/parts/filter/filter-item.html',[],function () { return '<span class="label label-primary">{{#t}}{{title}}{{/t}}</span>\n';});

